export const getEndOfFreeTrialDate = (startingDate = new Date()) => {
  const endDate = new Date(startingDate);

  endDate.setMonth(endDate.getMonth() + 1);

  return Math.floor(endDate.valueOf());
};

export const getMembershipPlanMonthlyNextBillingDate = getEndOfFreeTrialDate;
